<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage,Layout, PageHeader },
  data() {
    return {
      title: "Support Ticket Subject List",
      items: [
        {
          text: "Support Ticket",
          href: "/",
        },
        {
          text: "Subject List",
          active: true,
            errors:null,
            visible:false,
            message:"",
        },
      ],
      subjects: [],
    };
  },
  mounted() {
    this.getSubjectList();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    async deleteWarning(subject) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(subject);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async getSubjectList() {
      try {
        axios
          .get("/api/support-ticket/subject/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.subjects = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data load",
        });
      }
    },
    deleteItem: function deleteItem(subject) {
      var _this = this;
      axios
        .post("/api/support-ticket/subject/delete/" + subject.id, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
          if(response.data.status){
              _this.$swal.fire({
                  position: 'top-end',
                  icon: 'error',
                  title: 'Successfully Delete Support Ticket Subject',
                  showConfirmButton: false,
                  timer: 1000
              });
              _this.getAgentList();
              _this.hasDeleted = false;
              _this.getSubjectList();
              _this.hasDeleted = false;
          } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              _this.errorCheck(jsonParse);
          }
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>subject Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(subject,index) in subjects" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{subject.name}}</td>
                    <td><router-link :to="{ name: 'support_ticket_subject_update', params: {id: subject.id } }" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Edit</router-link> <button @click.prevent="deleteWarning(subject)" class="btn btn-danger btn-small"><i class="fa fa-trash"></i> Delete</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
